import tmhRequest from '@/config/tmhRequest'

export default {
    searchMemberStatusDetailReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberstatusdetailreport/searchmemberstatusdetailreportcount',
            method: 'post',
            data: data,
        })
    },
    searchMemberStatusDetailReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberstatusdetailreport/searchmemberstatusdetailreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportMemberStatusReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/memberstatusreport/exportmemberstatusreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/memberstatusdetailreport.js